import { DashboardSidebar } from "../components/Sidebar";
import { SidebarProvider } from "@acme/ui/sidebar";
import { Outlet } from "react-router";

export function AdminDashboardSidebarLayout() {
	return (
		<div className="flex h-screen w-screen overflow-hidden">
			<SidebarProvider>
				<DashboardSidebar />
				<main className="flex-1 overflow-y-auto">
					<Outlet />
				</main>
			</SidebarProvider>
		</div>
	);
}

export default AdminDashboardSidebarLayout;
